import { BaseRequest } from '@/network/requests/BaseRequest'
import { criteria_level } from '@/interfaces/criteria_level'
import { stringToBlob } from '@/util/stringToPlainTextBlob'

export const criteriaLevelRequest = BaseRequest.build<criteria_level>(`criteria_level`)

/**
 * 上传 xml 内容到 rule_info.files，并保存至 rule_info
 * @param content 文件内容
 * @param fileName 文件名
 * @param jtId 机台id
 * @param existFileId 已有文件Id，以供删除用。
 */
export const uploadFileFromContent = async (content: string, fileName: string, name: string, existFileId?: string | undefined) => {
	const contentType = 'text/plain'
	const blob = stringToBlob(content, fileName, contentType)
	const fileId = await criteriaLevelRequest.uploadFile(blob, contentType)

	//上传规则。
	return criteriaLevelRequest.upload({
		file_id: fileId,
		name: name,
	})
}
/**
 * 修改名称
 * @param fileId
 * @param name
 * @param existFileId
 */
export const EditFileFromContent = async (fileId: string, name: string, existFileId?: string | undefined) => {
	return criteriaLevelRequest.modifyById(fileId, { name: name })
}

/**
 * 修改文件内容。
 * @param content
 * @param fileName
 * @param fileId
 */
export const updateFileFromContent = async (content: string, fileName: string, fileId: string) => {
	const contentType = 'text/plain'
	const blob = stringToBlob(content, fileName, contentType)

	//上传新内容。
	var newFileId = await criteriaLevelRequest.uploadFile(blob, contentType, fileId)
	return newFileId
}

/**
 * 根据 rule_info_file_id 来获取文件内容
 * @param ruleInfoFileId
 */
export const getFileContent = (fileId: string) => {
	return criteriaLevelRequest.getFileContentById(fileId)
}

/**
 * 删除统一参数配置。
 * @param id
 * @param fileId
 */
export const deleteCrieriaLevel = (id, fileId) => {
	//先删除记录。
	var p1 = criteriaLevelRequest.deleteById(id)
	//再删除文件。
	var p2 = criteriaLevelRequest.deleteFileById(fileId)

	return Promise.all([p1, p2])
}
